const routineConfig = {
    // Timing labels:
    // ["AM"], ["PM"], ["AM", "PM"], ["2–3×/week"]

    productTiming: {
        // Cleanser
        "8555291246844": {
            timing: ["AM", "PM"]
        },
        "6243894100141": {
            timing: ["AM", "PM"]
        },

        // SPF
        "9323725979900": {
            timing: ["AM"]
        },
        "8991994478844": {
            timing: ["AM"]
        },
        "7869692150012": {
            timing: ["AM"]
        },

        // Vitamin C / antioxidant products
        "9037204553980": {
            timing: ["AM"]
        },
        "7783933444348": {
            timing: ["AM"]
        },

        // Barrier / moisturizer / restorative products
        "9157487427836": {
            timing: ["AM", "PM"]
        },
        "5767941947545": {
            timing: ["AM", "PM"]
        },
        "9292267323644": {
            timing: ["AM", "PM"]
        },

        // Eye products
        "5767402291353": {
            timing: ["AM", "PM"]
        },
        "8749386629372": {
            timing: ["AM", "PM"]
        },

        // Toners / pads
        "5767942439065": {
            timing: ["AM", "PM"],
            note: "Follow the selected routine's exfoliation instructions."
        },
        "5767942307993": {
            timing: ["AM", "PM"]
        },

        // Exfoliation
        "5767942996121": {
            timing: ["2–3×/week"],
            note: "Use according to the selected routine; avoid layering with products the routine instructs you to skip."
        },

        // Retinoid / renewal products
        "5767408582809": {
            timing: ["PM"]
        },
        "6092607094957": {
            timing: ["PM"]
        },
        "9083508392188": {
            timing: ["PM"],
            note: "Use the frequency specified by the matched routine."
        },

        // Brightening
        "8749444333820": {
            timing: ["AM", "PM"]
        },
        "5767942144153": {
            timing: ["AM"]
        },

        // Additional products
        "9022891032828": {
            timing: ["PM"],
            note: "Use as tolerated, according to the matched routine."
        },
        "9248835371260": {
            timing: ["AM", "PM"]
        },
        "8970796826876": {
            timing: ["AM", "PM"],
            note: "Timing needs to be confirmed in the routine specification."
        }
    }
};